import React from 'react'

const Howitworks = () => {
    return (
        <div  className="sec sec-blush">
            <div  className="container">
            <div  className="sec-label"><span  className="overline">How it works</span></div>
            <h2  className="disp-lg">One kit. One session.<br/> One score that actually means something.</h2>
            <div  className="steps">
                <div  className="step">
                    <div  className="step-n">1</div>
                    <h4>Mail your DNA kit</h4>
                    <p>Simple saliva collection. Return envelope included. CLIA lab processes 1,520 genes across 6 compatibility domains. Results in 3–4 weeks.</p>
                </div>
                <div  className="step">
                    <div  className="step-n">2</div>
                    <h4>Psychometric profile</h4>
                    <p>40-minute validated assessment: attachment style, values, personality, communication, emotional intelligence. Completes your compatibility profile.</p>
                </div>
                <div  className="step">
                    <div  className="step-n">3</div>
                    <h4>Match & schedule your session</h4>
                    <p>Your top DNA + psychometric matches surface in the app. Schedule a 60-minute live compatibility session with any match — before committing to a date.</p>
                </div>
                <div  className="step">
                    <div  className="step-n">4</div>
                    <h4>Live session: 25 questions, ~1 hour</h4>
                    <p>Apple Watch captures HRV, BP pattern score, and heart rate. Your camera captures facial expressions and voice. 25 structured questions across 5 domains — your body's answers are the real data.</p>
                </div>
            </div>
             
             <div className=" countersection">
            <div className="row ">
                <div className="col-md-5">
                    <h6>THE SESSION IN NUMBERS</h6>
                    <div className="grid g3">
                        <div className="numberbox"><div className="number">25</div><div className="numbertitle">structured questions</div></div>
                        <div className="numberbox"><div className="number">~60</div><div className="numbertitle">minutes total</div></div>
                        <div className="numberbox"><div className="number">5</div><div className="numbertitle">domains scored</div></div>
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="subheading">THREE SIMULTANEOUS DATA STREAMS</div>
                    <ul>
                        <li><span className="simultaneous ">⌚</span> Apple Watch — HRV, BP pattern score, heart rate, temperature</li>
                        <li><span className="simultaneous ">📹</span> Video + audio AI — facial expressions, voice prosody, gaze</li>
                        <li><span className="simultaneous ">💬</span> Verbal answers — semantically scored, matched against your partner's</li>
                    </ul>
                </div>
               <div className="col-md-2"> 
                <button  className="btn btn-coral btn-sm" onclick="go('science')">See the Full Session <span  className="arr">→</span></button>
           </div>
            </div>
        </div>
        </div>
        </div>
    )
}

export default Howitworks
